import { render, staticRenderFns } from "./ItemCaption.vue?vue&type=template&id=9ce14b86&scoped=true&"
import script from "./ItemCaption.vue?vue&type=script&lang=js&"
export * from "./ItemCaption.vue?vue&type=script&lang=js&"
import style0 from "./ItemCaption.vue?vue&type=style&index=0&id=9ce14b86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce14b86",
  null
  
)

export default component.exports